import { prismicSliceToAccordion } from 'prismic/slices/Accordion/AccordionSlice';
import { prismicSliceToCallToAction } from 'prismic/slices/CallToAction/CallToActionSlice';
import { prismicSliceToGoogleSheetTableSlice } from 'prismic/slices/GoogleSheetTable/GoogleSheetTableSlice';
import { prismicSliceToNumbers } from 'prismic/slices/Numbers/NumbersSlice';
import { prismicSliceToText } from 'prismic/slices/Text/TextSlice';
import {
  Power_StationSlices,
  Power_StationSlicesAccordion,
  Power_StationSlicesCall_To_Action,
  Power_StationSlicesGoogle_Sheet_Table,
  Power_StationSlicesNumbers,
  Power_StationSlicesText,
} from 'prismic-types';

import { ArticleSection } from 'components/article-section/ArticleSection';
import { Section } from 'components/section/Section';

type Props = {
  slices?: Array<Power_StationSlices>;
};

export function PowerStationSlices({ slices = [] }: Props) {
  return (
    <>
      {slices.map((s: Power_StationSlices, i: number) => {
        const key = `slice-${s.type}-${i}`;

        switch (s.type) {
          case 'call_to_action':
            return (
              <Section key={key}>
                {prismicSliceToCallToAction(
                  s as Power_StationSlicesCall_To_Action
                )}
              </Section>
            );
          case 'numbers':
            return (
              <Section key={key}>
                {prismicSliceToNumbers(s as Power_StationSlicesNumbers)}
              </Section>
            );
          case 'google_sheet_table':
            return (
              <ArticleSection key={key}>
                {prismicSliceToGoogleSheetTableSlice(
                  s as Power_StationSlicesGoogle_Sheet_Table
                )}
              </ArticleSection>
            );
          case 'accordion':
            return (
              <ArticleSection key={key}>
                {prismicSliceToAccordion(s as Power_StationSlicesAccordion)}
              </ArticleSection>
            );
          case 'text':
            return (
              <ArticleSection key={key}>
                {prismicSliceToText(
                  s as Power_StationSlicesText,
                  'powerStationImage'
                )}
              </ArticleSection>
            );
          default:
            console.info(`PowerStationSlices: unknown slice type ${s.type}`, s);
            return process.env.NODE_ENV === 'production' ? null : (
              <Section key={key}>{`unknown slice type ${s.type}`}</Section>
            );
        }
      })}
    </>
  );
}
